import React, { useState, useEffect, useRef } from "react";
import "../styles/InfoTooltip.css";

const studentTooltipContent = {
  "Audio Recorder": {
    howTo:
      "Click the microphone button on the left to start recording your voice. Your browser may ask for permission to use your microphone. You canlisten to your recording before submitting.",
    tips: "Test your microphone volume before starting. Speak at a natural pace and try to pronounce words clearly.",
  },
  "Audio Player": {
    howTo:
      "Press the play button to start the audio. Use the volume slider to adjust the sound level. You can speed up or slow down the audio using the speed controls. The waveform shows you the audio pattern - you can click anywhere on it to jump to that part.",
    tips: "Listen to the audio multiple times if needed. Try different playback speeds if you're having trouble understanding. Use headphones for better audio quality.",
  },
  "Multiple Choice": {
    howTo:
      "Read the question carefully and select ONE answer by clicking the radio button next to your chosen option. Your selection will be highlighted. You can change your answer by selecting a different option.",
    tips: "Read all options before making your choice. Eliminate obviously incorrect answers in your mind. Review your answer before submitting.",
  },
  "Multiple Checkbox": {
    howTo:
      "Read the question and select ALL correct answers by clicking the checkboxes next to them. You can select multiple options. Click a checkbox again to deselect it if you change your mind.",
    tips: "Consider each option independently. Don't assume there's only one correct answer. Make sure you've reviewed all options before submitting.",
  },
  "Fill in the Blanks": {
    howTo:
      "Type your answer in each blank space. Click or tab to move between blanks. Your answers should fit naturally into the sentence structure. Spelling and capitalization may matter.",
    tips: "Read the entire sentence first to understand the context. Pay attention to grammar and tense. Double-check your spelling before submitting.",
  },
  "Sentence Ordering": {
    howTo:
      "Drag and drop each sentence into the correct position. Click and hold a sentence to move it, then release to drop it in place. The goal is to create a logical, coherent paragraph.",
    tips: "Look for sequential clues like time words (first, then, finally). Identify the topic sentence that should go first. Make sure the final order tells a coherent story.",
  },
  "Spell the Word": {
    howTo:
      "Click on the letter pieces in the correct order to spell the word. If you make a mistake, you can click 'Reset' to start over. The letters must be arranged in the exact correct spelling.",
    tips: "Sound out the word if you're unsure. Break longer words into syllables.",
  },
  Pairing: {
    howTo:
      "Match items from the left column with their corresponding pairs in the right column. Click an item on the left, then click its matching item on the right to create a pair. Click a paired item to unlink it if you need to change it.",
    tips: "Start with the pairs you're most confident about",
  },
  OpenText: {
    howTo:
      "Write your response in the text editor. You can use the formatting tools to style your text, create lists, and organize your thoughts.",
    tips: "Take time to plan your response. Use paragraphs to organize your ideas. Review and edit your work before submitting.",
  },
};

const StudentInfoTooltip = ({ type }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const content = studentTooltipContent[type] || {};

  return (
    <div className="info-tooltip-container" ref={tooltipRef}>
      <button className="info-icon" onClick={() => setIsVisible(!isVisible)}>
        ?
      </button>
      {isVisible && (
        <div className="tooltip">
          <h3>{type}</h3>
          <h4>How to answer?</h4>
          <p>{content.howTo}</p>
          <h4>Helpful tips:</h4>
          <p>{content.tips}</p>
        </div>
      )}
    </div>
  );
};

export default StudentInfoTooltip;
